import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import React from 'react';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';

import { DeliverableContainerReceiptRecordGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { DownloadButton } from '../DownloadButton';

export const DeliverableReceiptsInputTable = ({
  currentReceipt,
}: {
  currentReceipt: DeliverableContainerReceiptRecordGQLType;
}) => {
  return (
    <>
      <Box overflowY="auto">
        <Table variant="simple" borderWidth="1px">
          <Thead fontSize="md" fontWeight="bold">
            <Tr>
              <Th>Name</Th>
              <Th>Type</Th>
              <Th>Due Date</Th>
              <Th />
            </Tr>
          </Thead>
          <Tbody fontSize="sm">
            {currentReceipt.dependenciesInstances.map((d) => {
              const fileName = `${currentReceipt.creditFacilitySlug}-${currentReceipt.containerType}-${currentReceipt.containerDueDate}-final-report-v${currentReceipt.version}-${d.artifactConfigKey}-${d.artifactReportingDate}`;
              return (
                <Tr key={d.receiptInstanceId}>
                  <Td>{commonUtils.toTitleCase(d.artifactConfigKey)}</Td>
                  <Td>{commonUtils.toTitleCase(d.artifactType)}</Td>
                  <Td>
                    {commonDate.fullDateStrToHumanDateString(
                      d.artifactReportingDate,
                    )}
                  </Td>
                  <Td>
                    <DownloadButton
                      fileName={fileName}
                      artifactInstanceId={d.receiptInstanceId}
                      iconOnly
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};
